import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="64"
    height="74"
    viewBox="0 0 64 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20.8768" cy="48.6405" r="11.3768" fill="#CE8C0C" />
    <circle
      cx="20.8768"
      cy="47.3761"
      r="11.3768"
      fill="url(#paint0_linear_1959_189)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.8769 55.5926C25.4148 55.5926 29.0935 51.9139 29.0935 47.376C29.0935 42.8382 25.4148 39.1595 20.8769 39.1595C16.339 39.1595 12.6603 42.8382 12.6603 47.376C12.6603 51.9139 16.339 55.5926 20.8769 55.5926ZM20.8769 56.8567C26.1129 56.8567 30.3575 52.6121 30.3575 47.376C30.3575 42.14 26.1129 37.8954 20.8769 37.8954C15.6409 37.8954 11.3962 42.14 11.3962 47.376C11.3962 52.6121 15.6409 56.8567 20.8769 56.8567Z"
      fill="#E2AB1A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.0932 47.376C29.0932 41.6876 24.3007 39.5168 23.0887 38.8435C21.8767 38.1701 20.8766 37.8954 20.8766 37.8954C26.1126 37.8954 30.3572 42.14 30.3572 47.376C30.3572 52.6121 26.1126 56.8567 20.8766 56.8567C20.8766 56.8567 21.1929 56.8515 23.0887 56.2246C24.9846 55.5978 29.0932 51.9139 29.0932 47.376Z"
      fill="#D89C00"
    />
    <path
      d="M20.4361 51.8006C19.3082 51.8006 18.2224 51.4916 17.2632 50.8187C16.5946 50.3499 15.8208 49.2914 15.8208 47.4968C15.8208 44.1675 17.4991 42.9524 20.8719 42.9524L25.7182 42.9524C25.7182 42.9524 25.8675 42.9446 25.9098 42.995C25.9631 43.0584 25.9098 43.2082 25.9098 43.2082L25.4538 44.6257C25.4538 44.6257 25.3934 44.7575 25.3307 44.8005C25.2574 44.8507 25.1381 44.8487 25.1381 44.8487H21.3347C19.1086 44.8487 17.7849 45.0246 17.7849 47.4968C17.7849 48.3134 18.0122 48.8946 18.4799 49.2732C19.2705 49.9133 20.807 49.9405 21.7459 49.8488C21.7459 49.8488 22.1311 48.5936 22.1946 48.3898C22.2689 48.151 22.2364 48.0941 22.0045 48.0941C21.6697 48.0941 21.0677 48.0941 20.4288 48.0941C19.9811 48.0941 19.5412 47.8657 19.5412 47.3173C19.5412 46.7876 19.9505 46.4802 20.5115 46.4802C21.4828 46.4802 23.4834 46.4802 23.8578 46.4802C24.3487 46.4802 24.8497 46.5515 24.5941 47.339L23.2405 51.4985C23.2405 51.4985 22.1348 51.8006 20.4361 51.8006Z"
      fill="#E2A60B"
    />
    <circle cx="42.5233" cy="23.5445" r="11.3768" fill="#CE8C0C" />
    <circle
      cx="42.5233"
      cy="22.2803"
      r="11.3768"
      fill="url(#paint1_linear_1959_189)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.5234 30.4968C47.0613 30.4968 50.7399 26.8181 50.7399 22.2802C50.7399 17.7423 47.0613 14.0636 42.5234 14.0636C37.9855 14.0636 34.3068 17.7423 34.3068 22.2802C34.3068 26.8181 37.9855 30.4968 42.5234 30.4968ZM42.5234 31.7609C47.7594 31.7609 52.004 27.5162 52.004 22.2802C52.004 17.0442 47.7594 12.7996 42.5234 12.7996C37.2874 12.7996 33.0427 17.0442 33.0427 22.2802C33.0427 27.5162 37.2874 31.7609 42.5234 31.7609Z"
      fill="#E2AB1A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.7398 22.2802C50.7398 16.5918 45.9473 14.421 44.7353 13.7476C43.5234 13.0742 42.5232 12.7996 42.5232 12.7996C47.7592 12.7996 52.0038 17.0442 52.0038 22.2802C52.0038 27.5162 47.7592 31.7609 42.5232 31.7609C42.5232 31.7609 42.8395 31.7557 44.7353 31.1288C46.6312 30.502 50.7398 26.8181 50.7398 22.2802Z"
      fill="#D89C00"
    />
    <path
      d="M42.0825 26.7048C40.9547 26.7048 39.8689 26.3958 38.9097 25.723C38.2411 25.2542 37.4673 24.1956 37.4673 22.401C37.4673 19.0717 39.1456 17.8566 42.5184 17.8566L47.3647 17.8566C47.3647 17.8566 47.514 17.8489 47.5563 17.8992C47.6096 17.9626 47.5563 18.1124 47.5563 18.1124L47.1002 19.5299C47.1002 19.5299 47.0399 19.6617 46.9772 19.7047C46.9038 19.755 46.7846 19.7529 46.7846 19.7529H42.9811C40.755 19.7529 39.4314 19.9288 39.4314 22.401C39.4314 23.2177 39.6586 23.7988 40.1264 24.1775C40.9169 24.8175 42.4535 24.8447 43.3924 24.753C43.3924 24.753 43.7776 23.4978 43.8411 23.2941C43.9154 23.0553 43.8828 22.9983 43.651 22.9983C43.3162 22.9983 42.7142 22.9983 42.0753 22.9983C41.6276 22.9983 41.1877 22.77 41.1877 22.2215C41.1877 21.6919 41.597 21.3845 42.158 21.3845C43.1293 21.3845 45.1299 21.3845 45.5043 21.3845C45.9952 21.3845 46.4962 21.4558 46.2406 22.2432L44.887 26.4028C44.887 26.4028 43.7813 26.7048 42.0825 26.7048Z"
      fill="#E2A60B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1959_189"
        x1="20.8768"
        y1="35.9993"
        x2="20.8768"
        y2="58.7529"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEDC28" />
        <stop offset="1" stopColor="#F1C34B" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1959_189"
        x1="42.5233"
        y1="10.9036"
        x2="42.5233"
        y2="33.6571"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEDC28" />
        <stop offset="1" stopColor="#F1C34B" />
      </linearGradient>
    </defs>
  </SvgIcon>
));
